var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-page-header',{attrs:{"content":_vm.content},on:{"back":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }